// extracted by mini-css-extract-plugin
module.exports = {"root":"ExtraCosts_root__2YQgA","header":"ExtraCosts_header__t97wz","content":"ExtraCosts_content__2Ropd","content__table":"ExtraCosts_content__table__IYS86"};